<div class="container-fluid dashboard-financeiro">
  <!-- Primeira Linha: Receitas e Despesas -->
  <div class="row">
    <!-- Coluna Receitas -->
    <div class="col-md-6 border-right">
      <div class="row">
        <div class="col-md-7">
          <div class="card-metric bg-green-custom">
            <div class="metric-title">Receitas</div>
            <div class="metric-value">{{ (dashboardData?.realReceitas ?? 0) | currency:'BRL':'symbol':'1.2-2' }}</div>
          </div>
          <div class="card-metric bg-green-light-custom mt-2">
            <div class="metric-title">Meta de Receitas</div>
            <div class="metric-value">{{ (dashboardData?.metaReceitas ?? 0) | currency:'BRL':'symbol':'1.2-2' }}</div>
          </div>
        </div>
        <div class="col-md-5">
          <div class="card-percentage bg-white">
            <div class="perc-label">%</div>
            <div class="perc-value text-green">
              {{ (dashboardData?.metaReceitas ? (dashboardData!.realReceitas / dashboardData!.metaReceitas * 100) : 0) | number:'1.0-0' }}%
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div class="chart-container text-center" style="height: 150px;">
            <div class="chart-title">Receita vs Meta</div>
            <canvas baseChart
                    [data]="barChartDataReceitas"
                    [options]="barChartOptions"
                    [type]="barChartType">
            </canvas>
          </div>
        </div>
      </div>
    </div>

    <!-- Coluna Despesas -->
    <div class="col-md-6">
      <div class="row">
        <div class="col-md-7">
          <div class="card-metric bg-red-custom">
            <div class="metric-title">Despesas</div>
            <div class="metric-value">{{ (dashboardData?.realDespesas ?? 0) | currency:'BRL':'symbol':'1.2-2' }}</div>
          </div>
          <div class="card-metric bg-orange-light-custom mt-2">
            <div class="metric-title">Meta de Despesas</div>
            <div class="metric-value">{{ (dashboardData?.metaDespesas ?? 0) | currency:'BRL':'symbol':'1.2-2' }}</div>
          </div>
        </div>
        <div class="col-md-5">
          <div class="card-percentage bg-white">
            <div class="perc-label">%</div>
            <div class="perc-value text-orange">
              {{ (dashboardData?.metaDespesas ? (dashboardData!.realDespesas / dashboardData!.metaDespesas * 100) : 0) | number:'1.0-0' }}%
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div class="chart-container text-center" style="height: 150px;">
            <div class="chart-title">Despesa vs Meta</div>
            <canvas baseChart
                    [data]="barChartDataDespesas"
                    [options]="barChartOptions"
                    [type]="barChartType">
            </canvas>
          </div>
        </div>
      </div>
    </div>
  </div>

  <hr>

  <!-- Segunda Linha: Gráficos de Rosca e Evolução -->
  <div class="row mt-4">
    <div class="col-md-3">
      <div class="chart-donut-container text-center" style="height: 180px;">
        <canvas baseChart
                [data]="donutChartData"
                [options]="donutChartOptions"
                [type]="donutChartType">
        </canvas>
      </div>
    </div>
    <div class="col-md-3 border-left border-right">
      <div class="chart-container text-center" style="height: 180px;">
        <div class="chart-title">Resultado</div>
        <canvas baseChart
                [data]="resultadoChartData"
                [options]="barChartOptions"
                [type]="barChartType">
        </canvas>
      </div>
    </div>
    <div class="col-md-3">
      <div class="chart-donut-container text-center" style="height: 180px;">
        <div class="chart-title">Composição</div>
        <canvas baseChart
                [data]="donutChartData"
                [options]="donutChartOptions"
                [type]="donutChartType">
        </canvas>
      </div>
    </div>
    <div class="col-md-3 border-left">
      <div class="chart-container text-center" style="height: 180px;">
        <div class="chart-title">Lucratividade</div>
        <canvas baseChart
                [data]="lineChartDataLucratividade"
                [options]="lineChartOptions"
                [type]="lineChartType">
        </canvas>
      </div>
    </div>
  </div>

  <hr>

  <!-- Terceira Linha: Contas e Saldo -->
  <div class="row mt-4">
    <div class="col-md-3">
      <div class="card-metric bg-green-light-custom">
        <div class="metric-title">Contas a Receber</div>
        <div class="metric-value">{{ (dashboardData?.totalContasReceber ?? 0) | currency:'BRL':'symbol':'1.2-2' }}</div>
      </div>
      <div class="card-metric bg-orange-light-custom mt-2">
        <div class="metric-title">Contas a Pagar</div>
        <div class="metric-value">{{ (dashboardData?.totalContasPagar ?? 0) | currency:'BRL':'symbol':'1.2-2' }}</div>
      </div>
    </div>
    <div class="col-md-3 border-left border-right">
      <div class="chart-container text-center" style="height: 100px;">
        <canvas baseChart
                [data]="barChartDataComparativo"
                [options]="barChartOptions"
                [type]="barChartType">
        </canvas>
      </div>
    </div>
    <div class="col-md-3">
      <div class="card-metric bg-blue-dark-custom">
        <div class="metric-title text-white">Resultado</div>
        <div class="metric-value text-white">{{ (dashboardData?.resultado ?? 0) | currency:'BRL':'symbol':'1.2-2' }}</div>
      </div>
      <div class="card-metric bg-blue-light-custom mt-2">
        <div class="metric-title">Meta de Resultado</div>
        <div class="metric-value">{{ (dashboardData?.metaResultado ?? 0) | currency:'BRL':'symbol':'1.2-2' }}</div>
      </div>
    </div>
    <div class="col-md-1">
      <div class="card-percentage bg-white">
        <div class="perc-label">%</div>
        <div class="perc-value text-green">
          {{ (dashboardData?.metaResultado ? (dashboardData!.resultado / dashboardData!.metaResultado * 100) : 0) | number:'1.0-0' }}%
        </div>
      </div>
    </div>
    <div class="col-md-2 border-left">
      <div class="chart-container text-center" style="height: 100px;">
        <div class="chart-title">Saldo</div>
        <canvas baseChart
                [data]="waveChartDataSaldo"
                [options]="waveChartOptions"
                [type]="lineChartType">
        </canvas>
      </div>
    </div>
  </div>
</div>
